const ArrowDown = ({ style }) => {
    return (
        <span style={{marginLeft: '5px', ...style}}>&#x2193;</span>
    )
}

export default ArrowDown;